<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<style lang="stylus">
	@import './style/core/';

  html {
    color: #666;
  }
</style>

<script>
  export default {
    name: 'app'
  }
</script>



// WEBPACK FOOTER //
// App.vue?5ac20293